import { useState, useEffect, useCallback } from 'react';
import { toaster } from 'evergreen-ui';
import api from '../../../services/api';

export const useSearch = (currentProject) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState({
    services: [],
    domains: [],
    hosts: [],
    webapps: [],
    urls: [],
    findings: []
  });
  const [isSearching, setIsSearching] = useState(false);

  const performSearch = useCallback(async (query) => {
    if (!query.trim() || !currentProject?.id) {
      setSearchResults({
        services: [],
        domains: [],
        hosts: [],
        webapps: [],
        urls: [],
        findings: []
      });
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    
    try {
      const response = await api.get(`/projects/${currentProject.id}/results/search`, {
        params: { 
          query: query.trim(),
          limit: 100
        }
      });
      
      if (response.data && response.data.results) {
        setSearchResults(response.data.results);
      } else {
        setSearchResults({
          services: [],
          domains: [],
          hosts: [],
          webapps: [],
          urls: [],
          findings: []
        });
      }
    } catch (error) {
      console.error('Search error:', error);
      toaster.danger('Search failed. Please try again.');
      setSearchResults({
        services: [],
        domains: [],
        hosts: [],
        webapps: [],
        urls: [],
        findings: []
      });
    } finally {
      setIsSearching(false);
    }
  }, [currentProject?.id]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQuery.trim()) {
        performSearch(searchQuery);
      } else {
        setSearchResults({
          services: [],
          domains: [],
          hosts: [],
          webapps: [],
          urls: [],
          findings: []
        });
        setIsSearching(false);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchQuery, performSearch]);

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    isSearching
  };
};

